import { render } from "./ListMyAgreements.vue?vue&type=template&id=03052d94&scoped=true"
import script from "./ListMyAgreements.vue?vue&type=script&lang=js"
export * from "./ListMyAgreements.vue?vue&type=script&lang=js"

import "./ListMyAgreements.vue?vue&type=style&index=0&id=03052d94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03052d94"]])

export default __exports__